// extracted by mini-css-extract-plugin
export default {"section":"ChooseAccountForPaymentMethodsModal_section__1+Yl-","name":"ChooseAccountForPaymentMethodsModal_name__SyTor"};